<template>
  <div class="utility-buttons-wrapper py-26 px-16 border border-1 border-end-0 border-start-0 border-bottom-0" >
    <div class="utility-buttons-inner d-flex align-items-center justify-content-between">
      <label class="label fs-12">{{ label }}</label>
      <div class="toggle-button d-flex align-items-center">
        <div class="toggle-label">
          <label
            :class="[isToggled ? 'd-none': 'd-block']"
            class="fs-12 me-10 text-medium-gray">Off</label>
          <label
            :class="[isToggled ? 'd-block': 'd-none']"
            class="fs-12 me-10 text-medium-gray" >On</label>
        </div>
        <label class="switch position-relative d-inline-block">
          <input
            v-model="isToggled"
            :disabled="this.label === 'Video Mode:' && this.$store.getters['activeProduct/getIsVideoMoodOn']"
            class="h-0 w-0"
            type="checkbox"
            @change="toggleHandler">
          <span class="slider round border border-1  border-dark-gray position-absolute "/>
        </label>
      </div>
    </div>

  </div>
</template>
<script>
import EventBus from '@/EventBus';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';

export default {
  name:  'UtilityButtonsPanel',
  props: {
    label:                String,
    id:                   { String, Number },
    isToggled:            { type: Boolean, default: false },
    isSameDimensionPages: { type: Boolean, default: false },
  },
  data() {
    return {
    };
  },
  mounted() {
    EventBus.$on('resetToggleButton', this.resetToggle);
  },
  destroyed() {
    EventBus.$off('resetToggleButton', this.resetToggle);
  },
  methods: {
    resetToggle() {
      this.isToggled = false;
    },
    toggleHandler() {
      if (this.label === 'Crop Marks') {
        EventBus.$emit('changeProductAllowCropping', !this.isToggled);
      } else if (this.label === 'Alignment Guides:') {
        this.$store.commit('setSnappingEnabled');
      } else if (this.label === 'Grayscale PDF:') {
        EventBus.$emit('toggleGrayScale');
      } else if (this.label === 'Show Rulers:') {
        EventBus.$emit('toggleRuler');
      } else if (this.label === 'Video Mode:' && !this.$store.getters['activeProduct/getIsVideoMoodOn']) {
        if (this.isSameDimensionPages) {
          this.$store.commit('activeProduct/updateIsVideoMoodOn', true);
          EventBus.$emit(ApplicationEventTypes.Video.ToggleVideoMood, true);
        } else {
          this.$store.commit('activeProduct/updateVideoConfirmationModel', true);
        }
      }
    },
  },

};

</script>
<style lang="scss" scoped>
    .switch{
        .slider {
            &:hover {
                border-color: $grey90 !important;
            }
            &:before{
                border-color: $grey90 !important;
            }
        }


    }
</style>
